import type { Post, PostStep, TourPosition } from './types';

/** One screen of the popup: which post, which of its steps, and where that sits in the popup. */
export interface TourPage {
  post: Post;
  screen: PostStep;
  at: TourPosition;
}

/** A post's screens: its tour, or one screen made of its own title, summary and media. */
export const postSteps = (post: Post): PostStep[] =>
  post.steps?.length ? post.steps : [{ label: post.area, title: post.title, body: post.summary, media: post.media }];

/** Every screen of a popup in order: each post's steps, the posts newest first. */
export const tourPages = (posts: Post[]): TourPage[] =>
  posts.flatMap((post, page) => {
    const steps = postSteps(post);
    return steps.map((screen, step) => ({ post, screen, at: { page, pages: posts.length, step, steps: steps.length } }));
  });
